import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, Stack, useText } from "@sveabank/cc-common";
import { useLazyFetchApplicationRevisionQuery } from "../../../services/application";
import { useDeleteClcApplicationMutation } from "../../../services/clc-application";

type Props = {
	open: boolean;
	closeModal: () => void;
	applicationId: string;
};

export const DeleteClcModal = ({ open, closeModal, applicationId }: Props) => {
	const [t, texts] = useText();

	const [fetchRevisionQuery] = useLazyFetchApplicationRevisionQuery();

	const [deleteClcApplicationMutation, { isLoading: isDeletingClcApplication }] =
		useDeleteClcApplicationMutation();

	const onClose = () => {
		closeModal();
	};

	const onDelete = async () => {
		await fetchRevisionQuery(applicationId).unwrap();
		await deleteClcApplicationMutation(applicationId).unwrap();
		closeModal();
	};

	return (
		<Dialog
			isOpen={open}
			isDismissable={false}
			center
			size="small"
			heading={t(texts.newCompany.deleteModal.heading)}
			icon="warning"
		>
			<Dialog.Content>
				<Stack gap={4}>{t(texts.newCompany.deleteModal.text)}</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={onDelete} isPending={isDeletingClcApplication}>
						{t(texts.newCompany.deleteModal.deleteButtonText)}
					</Button>
					<Button onPress={onClose} variant="secondary">
						{t(texts.newCompany.deleteModal.closeButtonText)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
